module.exports = __webpack_public_path__ + "img/KSC02851.f5ac62a1.jpg";